import { render, staticRenderFns } from "./variAttr.vue?vue&type=template&id=a79d870c&scoped=true"
import script from "./variAttr.vue?vue&type=script&lang=js"
export * from "./variAttr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79d870c",
  null
  
)

export default component.exports